module.exports = __webpack_public_path__ + "img/ZB6109_6.138a2712.jpg";